/*
 * @Author: Haotao
 * @Date: 2022-10-13 13:06:22-02 14:24:13
 * @LastEditors: Haotao
 */
import service, { servicePre } from '@utils/request'

// 获取验证码
const getVeriCode = (data) => {
  return servicePre({
    url: '/h5/login/verify',
    method: 'post',
    data: data
  })
}

// 登录
const loginning = (data) => {
  return servicePre({
    url: '/h5/login/record',
    method: 'post',
    data: data
  })
}

// 输入身份证
const inputIdNum = (data) => {
  return servicePre({
    url: '/h5/login/queryInfo',
    method: 'post',
    data: data
  })
}

// 微信解绑
const unitWeChat = () => {
  return service({
    url: 'front/personalController/untieWeChat',
    method: 'post'
  })
}

// 微信登录
const loginByWXCode = data => {
  return service({
    url: '/h5/login/chat',
    method: 'post',
    data
  })
}

export { getVeriCode, loginning, inputIdNum, unitWeChat, loginByWXCode }
